import { TELECONSULTATION_MODES } from "constants/teleconsultationModes";

function teleconsultationModeToLabel(code) {
  return TELECONSULTATION_MODES[code];
}

export { teleconsultationModeToLabel };
